import "bootstrap";
import "../scss/main.scss";
import "lightbox2";
import "./config/jquery";
import { tns } from "tiny-slider/src/tiny-slider";
import AOS from "aos";
import "aos/dist/aos.css";

// Initializing AOS library for fade-in effects on scrolling down page - infographic component || TODO: only run for page with infographic component
AOS.init();

// Initialize tiny-slider
if (document.body.contains(document.getElementById("testimonial_slider"))) {
  const nodeList = document.querySelectorAll("#testimonial_slider");
  [].forEach.call(nodeList, function(item) {
    tns({
      container: item,
      mode: "carousel",
      items: 1,
      center: true,
      mouseDrag: true,
      swipeAngle: false,
      autoHeight: false,
      speed: 400,
      controls: false,
      nav: true,
      navPosition: "bottom",
      gutter: 400
    });
  });
}

window.addEventListener("load", () => {
  setTimeout(() => {
    if (window.location.hash) {
      const hash = window.location.hash;
      window.location.hash = "";
      window.location.hash = hash;
    }
  }, 50);
});
document.querySelectorAll("*[id]").forEach(element => {
  if (element.id.includes(" ")) element.id = element.id.replace(/[ ]/g, "_");
  element.id = element.id.trim();
});

if (document.body.contains(document.getElementById("#subnav"))) {
  // Build sticky subnav component from anchors in-page
  document.querySelector(".subnav-nav").innerHTML = Array.prototype.slice
    .call(document.querySelectorAll("a"))
    .filter(function(a) {
      return a.id != "";
    })
    .map(function(a) {
      return {
        url: a.id,
        text: a.id
          .replace("ae", "æ")
          .replace("aa", "å")
          .replace(/_/g, " ")
      };
    })
    .map(function(a) {
      return '<li><a href="#' + a.url + '">' + a.text + "</a></li>";
    })
    .join("");

  // Animate scrolling from anchor links in sticky subnav
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener("click", function(e) {
      e.preventDefault();

      const element =
        Array.from(document.querySelectorAll("*[id]")).filter(
          x => x.id == this.getAttribute("href").replace(/^#/, "")
        )[0] || null;
      if (element != null) {
        element.scrollIntoView({
          behavior: "smooth",
          block: "center"
        });
      }
    });
  });
}
